module.exports = __webpack_public_path__ + "img/xbox-red.492406e3.png";